var map = {
	"./AZLogo.png": 2763,
	"./AboutMeAbu.png": 1874,
	"./ArrowDown.png": 6036,
	"./CascadiaCode.ttf": 6325,
	"./Close.png": 1171,
	"./DPImg1.png": 7669,
	"./DPImg2.png": 5870,
	"./DPImg3.png": 8887,
	"./DPImg4.png": 3720,
	"./DigitalPathology.png": 5956,
	"./Focus Image.png": 128,
	"./FocusImg1.jpg": 6641,
	"./FocusImg2.jpg": 8886,
	"./FocusImg3.jpg": 8371,
	"./FocusImg4.jpg": 5744,
	"./GithubLogo.png": 4815,
	"./HomeIcon.png": 3709,
	"./HumImg1.jpg": 6603,
	"./HumImg2.jpg": 9628,
	"./HumImg3.jpg": 1241,
	"./HumImg4.jpg": 4778,
	"./HumImg5.jpg": 5943,
	"./HygImg1.jpg": 7405,
	"./HygImg2.jpg": 4498,
	"./HygImg3.jpg": 7167,
	"./HygImg4.jpg": 4,
	"./Hygia Image.png": 7382,
	"./Jai.TTF": 2855,
	"./LatexAbuOG_Frontend.pdf": 8784,
	"./LinkedinLogo.png": 2096,
	"./MailLogo.png": 9911,
	"./OtherLogo.png": 2880,
	"./ProjectsIcon.png": 5522,
	"./ResumeIcon.png": 3561,
	"./ResumeLogo.png": 1187,
	"./Roof Img.png": 4332,
	"./RoofImg1.jpg": 6987,
	"./RoofImg2.jpg": 4188,
	"./SchoolIcon.png": 7448,
	"./Screen.png": 9475,
	"./Search icon.png": 2544,
	"./SendIcon.png": 1982,
	"./SubImg1.png": 711,
	"./SubImg2.png": 2236,
	"./SubImg3.png": 5125,
	"./SubImg4.png": 826,
	"./Tango.ttf": 8064,
	"./TheSubmissions.png": 6547,
	"./Trid1Img1.gif": 68,
	"./Trid1Img2.png": 8588,
	"./Trid2Img1.jpg": 9564,
	"./Trid2Img2.png": 2803,
	"./Trid2Img3.png": 3946,
	"./Trid2Img4.png": 821,
	"./Tridiuum 1 Image.png": 4132,
	"./Tridiuum 2 Image.png": 2219,
	"./VAC Image 2.png": 6856,
	"./VAC Image.png": 5714,
	"./VACImg1.jpg": 9371,
	"./VACImg2.jpg": 2924,
	"./VACImg3.jpg": 969,
	"./VACImg4.jpg": 282,
	"./VACImg5.jpg": 7767,
	"./WorkIcon.png": 8855,
	"./landingImg.png": 8649,
	"./nextBtn.png": 8590,
	"./noImages.png": 8224,
	"./prevBtn.png": 802,
	"./txtLogo.png": 3474
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8335;